export function getServicesListDivider(
  productsLength: number,
  categoriesLength: number,
  servicesLength: number,
) {
  return (productsLength > 0 || categoriesLength > 0) && servicesLength > 0;
}
